function cloudinarySourceSetAdapter(sourceSet) {
	let sourceSetString = "";
	let sizesString = "";
	let largestImage = null;

	const source = {
		src: "",
		srcSet: "",
		sizes: "",
	};

	if (!sourceSet) {
		return null;
	}

	if (sourceSet?.[0]) {
		largestImage = sourceSet?.[0]?.cloudinaryAsset?.[0];
	}

	for (let i = 0; i < sourceSet.length; i++) {
		const currentImage = sourceSet?.[i]?.cloudinaryAsset?.[0];
		const currentDisplayAt = sourceSet?.[i]?.sourceSetDisplayAt;

		if (largestImage && currentImage?.width > largestImage?.width) {
			largestImage = currentImage;
		}

		if (currentImage?.secure_url && currentImage?.width) {
			sourceSetString += `${currentImage.secure_url} ${currentImage?.width}w`;

			if (i < sourceSet.length - 1) {
				sourceSetString += ", ";
			}
		}

		if (currentDisplayAt !== null && currentImage?.width) {
			sizesString += `(min-width: ${currentDisplayAt}px) ${currentImage?.width}px`;

			if (i < sourceSet.length - 1) {
				sizesString += ", ";
			}
		}
	}

	if (largestImage?.secure_url) {
		source.src = largestImage.secure_url;
	}

	if (sourceSetString) {
		source.srcSet = sourceSetString;
	}

	if (sizesString) {
		source.sizes = sizesString;
	}

	return source;
}

export default cloudinarySourceSetAdapter;
export { cloudinarySourceSetAdapter };
